import React, { memo, useState } from "react";
import SVG from "react-inlinesvg";
import {Button, Tooltip} from "@material-ui/core";
import { CustomDialog } from "~components";
import { useEditorFieldOption } from "~store";

const OptionDelete = memo(({ row }) => {

  const [, optionActions] = useEditorFieldOption();
  const [triggerClose, setTriggerClose] = useState(false);
  const [message, setMessage] = useState("");

  const deleteOption = async (id) => {
    setMessage("Deleting ...");
    await optionActions.deleteOption(id);
    setMessage("Successfully deleted.");

    setTimeout(
            function() {
              setTriggerClose(true);
            }, 1500
    );
  }

  return(
    <CustomDialog
      title={""}
      dividers={false}
      maxWidth={"sm"}
      onExit ={() => optionActions.fetchOptions()}
      triggerCloseButton={triggerClose}
      triggerButton={
        <Tooltip arrow title={"Delete"}>
          <button className="btn btn-icon btn-light btn-hover-danger btn-sm">
            <span className="svg-icon svg-icon-md svg-icon-danger">
              <SVG src={"/media/svg/icons/General/Trash.svg"} />
            </span>
          </button>
        </Tooltip>
      }
        actionButtons={
          <Button
            className={"btn btn-danger btn-elevate"}
            onClick={() => deleteOption(row.id)}
          >
            Yes
          </Button>
        }
    >
      <div className={"font-size-h3 w-100 text-center py-10"}>
        {!message
        && (
            <span>
              Are you sure you want to delete this option (<span className={"font-weight-bold"}>{row.option}</span>)?
            </span>
        )}
        {message && message}
      </div>
    </CustomDialog>
  )
});

export default memo(OptionDelete);
